import { render, staticRenderFns } from "./Put.vue?vue&type=template&id=5f64df67"
import script from "./Put.vue?vue&type=script&lang=js"
export * from "./Put.vue?vue&type=script&lang=js"
import style0 from "./Put.vue?vue&type=style&index=0&id=5f64df67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports